module.exports = __webpack_public_path__ + "static/media/home4_1.f01aeacb.mp4";